export default __webpack_public_path__ + "static/media/manual_armario_inteligente.2810afe0.pdf";